import api from '@/api'
import { obtainToken } from '@/api/auth'

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status
}

const state = {
  authUser: {},
  status: '',
  token: localStorage.getItem('token')
}

const actions = {
  login ({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      obtainToken(user)
        .then(resp => {
          const token = resp.data.token
          localStorage.setItem('token', token)
          api.defaults.headers.common['Authorization'] = `Token ${token}`
          commit('auth_success', token)
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          localStorage.removeItem('token')
          reject(err)
        })
    })
  },

  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
      localStorage.removeItem('token')
      delete api.defaults.headers.common['Authorization']
      resolve()
      window.location = '/'
    })
  },

  initialAuth ({ dispatch }) {
    return dispatch('login', {
      username: process.env.VUE_APP_API_USERNAME,
      password: process.env.VUE_APP_API_PASSWORD
    })
  }
}

const mutations = {
  auth_request (state) {
    state.status = 'loading'
  },
  auth_success (state, token) {
    state.status = 'success'
    state.token = token
  },
  auth_error (state) {
    state.status = 'error'
  },
  logout (state) {
    state.status = ''
    state.token = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
